(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-shop-video"]) return;
  try {
    
  window.addEventListener('load', function() {
    const player = new ShopTheVideo()
    player.init()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super()
        }

        hide() {
          super.hide()
        }

        show(opener) {
          super.show(opener)
          this.showActiveMedia()
        }

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
          ).forEach((element) => {
            element.classList.remove('active')
          })
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`)
          const activeMediaTemplate = activeMedia.querySelector('template')
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null
          activeMedia.classList.add('active')
          activeMedia.scrollIntoView()

          const container = this.querySelector('[role="document"]')
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent()
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-landing-dropdown-cta"]) return;
  try {
    
  const dropper = document.querySelector('.holiday__dropdown__button')
  const dropdownInfo = document.querySelector('.holiday__dropdown')
  dropper.addEventListener('click', () => {
    if (dropdownInfo.style.maxHeight == '500px') {
      dropdownInfo.style.maxHeight = '40px'
    } else {
      dropdownInfo.style.maxHeight = '500px'
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-shop-video"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function () {
    const player = new ShopTheVideo()
    player.init()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-suggestions"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              // create swiperjs instance here
              const sliderOptions = {
                slidesPerView: 2.1,
                spaceBetween: 4,
                centeredSlides: true,
                loop: true,
                breakpoints: {
                  768: {
                    spaceBetween: 16,
                    slidesPerView: 3,
                    centeredSlides: false,
                    threshold: 32,
                    navigation: {
                      nextEl: '.pdp__suggestions__content__next',
                      prevEl: '.pdp__suggestions__content__prev'
                    }
                  },
                  1024: {
                    spaceBetween: 16,
                    slidesPerView: 4,
                    centeredSlides: false,
                    threshold: 32,
                    navigation: {
                      nextEl: '.pdp__suggestions__content__next',
                      prevEl: '.pdp__suggestions__content__prev'
                    }
                  }
                }
              }

              new Swiper('.pdp__suggestions__content__slider', sliderOptions)
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
